module.exports = __webpack_public_path__ + "media/components/assets/img/logo/wizzair-5464b4f592cf7136ddbddce19aaaf28d.png";